import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { Analytics } from '@vercel/analytics/react';

import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './App';
import Theme from './Theme';

ReactDOM.render(
  <ThemeProvider theme={Theme}>
    <CssBaseline />
    <App />
    <Analytics />
  </ThemeProvider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
